export const PAGES_TO_INCLUDE_FOR_APPLE_PAY = [
  '/checkout/payment',
  '/pages/subscription-payment',
  '/payment/3ds',
];
